import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect';
import checkPermission from '../../../../../Components/Hooks/PermissionHook';
import { approveCreative } from '../../../../../slices/campaigns/thunk';

function ApproveAllBtn() {
  const dispatch = useDispatch();

  const selectFilteredCreatives = createSelector(state => state.Campaign, state => state.filteredCreatives);
  const filteredCreatives = useSelector(selectFilteredCreatives);

  function approveAll() {
    const ids = filteredCreatives.filter(item => item.approvement === false).map(item => item._id);
    if (ids.length > 0) {
      dispatch(approveCreative(ids));
    }
  }

  const selectMenuPath = createSelector(state => state.MenuData, state => ({
    brandPath: state.brandPath,
    marketPath: state.marketPath,
  }));
  const { brandPath, marketPath } = useSelector(selectMenuPath);

  if (checkPermission((marketPath ? "markets" : "brands"), (marketPath ? marketPath : brandPath), "campaignEdit")) {
    return (
      <button className='btn btn-ghost-success' onClick={approveAll}>
        <i className='ri-thumb-up-fill align-middle me-1'></i>
        Approve All
      </button>
    )
  } else {
    return null;
  }
}

export default ApproveAllBtn
